import Vue from 'vue';
import axios from 'axios'
import {Toast} from 'vant';

Vue.use(Toast);

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL, // api 的 base_url
    timeout: 60000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        var authorization = process.env.VUE_APP_AUTH;
        config.headers['Authorization'] = authorization
        config.headers['Content-Type'] = 'application/json;charset=UTF-8'
        return config
    },
    error => {
        console.log(error) // for debug
        Toast('请求超时')
        Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
        return response
    },
    error => {
        console.log('err' + error)
        error.message = '连接服务器失败!'
        Toast(error.message)
        return Promise.reject(error)
    }
)

export default service
